import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-pi-details-modal',
  templateUrl: './pi-details-modal.component.html',
  styleUrls: ['./pi-details-modal.component.css'],
})
export class PiDetailsModalComponent implements OnInit {
  @Input() userIndex!: number;
  @Input() userIndexDiff!: number;
  @Input() userIndexAmbassador!: number;
  @Input() userIndexCreator!: number;
  @Input() userIndexHelper!: number;

  constructor() {}

  ngOnInit() {
    environment.log('PI Details Modal Opened');
  }
}
